export default {
  borderRadius: '6px',
}
